import { render, staticRenderFns } from "./BdRegister.vue?vue&type=template&id=4f08a686&scoped=true&"
import script from "./BdRegister.vue?vue&type=script&lang=js&"
export * from "./BdRegister.vue?vue&type=script&lang=js&"
import style0 from "./BdRegister.vue?vue&type=style&index=0&id=4f08a686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08a686",
  null
  
)

export default component.exports